import { render } from "./EsqueciMinhaSenha.vue?vue&type=template&id=1f7a6ffb&scoped=true&ts=true"
import script from "./EsqueciMinhaSenha.vue?vue&type=script&lang=ts"
export * from "./EsqueciMinhaSenha.vue?vue&type=script&lang=ts"

import "./EsqueciMinhaSenha.vue?vue&type=style&index=0&id=1f7a6ffb&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7a6ffb"]])

export default __exports__